import { object, string, number, bool, setLocale } from 'yup'
import { es } from 'yup-locales'

setLocale(es)

export const paymentScheme = object({
  payment_type: string().required().label('Tipo de pago'),
  customer_document_type: object().required().label('Tipo de documento'),
  customer_document_number: string().required().label('N° Documento'),

  // CARD
  // customer_full_name: string().when('payment_type', { is: 'card', then: (scheme) => scheme.required() }).min('2').max(30).matches(/^[a-zA-Z\s]*$/).label('Titular'),
  card_number: number().when('payment_type', { is: 'card', then: (scheme) => scheme.required() }).label('Número de tarjeta'),
  card_expiration_date: string().when('payment_type', { is: 'card', then: (scheme) => scheme.required() }).max(5).label('F. Vencimiento'),
  card_cvv: string().when('payment_type', { is: 'card', then: (scheme) => scheme.required() }).label('CVV'),

  // PSE
  bank: object().when('payment_type', { is: 'pse', then: (scheme) => scheme.required() }).label('Banco'),
  account_number: number().when('payment_type', { is: 'pse', then: (scheme) => scheme.required() }).label('Número de cuenta'),
  account_type: object().when('payment_type', { is: 'pse', then: (scheme) => scheme.required() }).label('Tipo de cuenta'),
  customer_firstname: string().required().min(2).max(20).matches(/^[a-zA-Z\s]*$/).label('Nombres'),
  customer_lastname: string().required().min(2).max(20).matches(/^[a-zA-Z\s]*$/).label('Apellidos'),

  terms_of_use: bool().oneOf([true], 'El campo debe estar marcado').required().label('Términos y condiciones'),
  // terms_of_debits: bool().oneOf([true], 'El campo debe estar marcado').required().label('Autorización'),
})
